module.exports = __webpack_public_path__ + "01d2f5fd9393dcda6a0cf738543ce58c.jpg";